import React, { useEffect, useState } from 'react'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
  TextField,
  Box,
} from '@mui/material'

const currencySymbols = ['$', '€', '¥', '£', 'A$', 'C$', 'CHF', '¥', 'kr', '₹']

const CurrencyRangeComponent = ({ onChange, clear, value }) => {
  const [selectedCurrency, setSelectedCurrency] = useState(value?.currency || '₹')
  const [initialNumber, setInitialNumber] = useState(value?.range[0])
  const [lastNumber, setLastNumber] = useState(value?.range[1])

  const triggerFilter = (currency, initial, last) => {
    const range = [initial, last !== null ? last : Infinity]
    onChange({ currency, range })
  }

  const handleCurrencyChange = (event) => {
    const currency = event.target.value
    setSelectedCurrency(currency)
    triggerFilter(currency, initialNumber, lastNumber)
  }

  const handleInitialChange = (e) => {
    const value = parseFloat(e.target.value)
    const initial = isNaN(value) ? null : value
    setInitialNumber(initial)
    triggerFilter(selectedCurrency, initial, lastNumber)
  }
  const handleLastChange = (e) => {
    const value = parseFloat(e.target.value)
    const last = isNaN(value) ? null : value
    setLastNumber(last)
    triggerFilter(selectedCurrency, initialNumber, last)
  }

  useEffect(() => {
    if (clear) {
      setInitialNumber(null)
      setLastNumber(null)
    }
  }, [clear])

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
      <FormControl
        sx={{
          minWidth: '40px',
          height: 33,
          '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary',
            paddingRight: '0px',
          },
        }}
      >
        <InputLabel>{selectedCurrency}</InputLabel>
        <Select
          value={selectedCurrency}
          onChange={handleCurrencyChange}
          input={<OutlinedInput label="Currency" />}
          color="primary"
          sx={{
            '& .MuiSelect-select': {
              padding: '8.5px 6px',
              paddingRight: '0px !important',
            },
            '& .MuiSelect-icon': {
              right: '0px',
              paddingRight: '0px',
            },
          }}
        >
          {currencySymbols.map((symbol, index) => (
            <MenuItem key={index} value={symbol}>
              {symbol}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        gap={0.5}
      >
        <TextField
          type="number"
          value={initialNumber !== null ? initialNumber : ''}
          onChange={handleInitialChange}
          color="primary"
          placeholder="From"
          variant="outlined"
          size="small"
          sx={{
            minWidth: '100px',
            '& .MuiOutlinedInput-root': {
              height: '22px',
            },
          }}
        />
        <TextField
          type="number"
          value={lastNumber !== null ? lastNumber : ''}
          color="primary"
          onChange={handleLastChange}
          placeholder="To"
          variant="outlined"
          size="small"
          sx={{
            minWidth: '100px',
            '& .MuiOutlinedInput-root': {
              height: '22px',
            },
          }}
        />
      </Box>
    </Box>
  )
}

export default CurrencyRangeComponent
